"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));
var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));
var _mobx = require("mobx");
var _utils = require("@seedlang/utils");
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10, _descriptor11, _descriptor12;
var CookieStore = (_class = /*#__PURE__*/function () {
  function CookieStore() {
    (0, _classCallCheck2["default"])(this, CookieStore);
    (0, _initializerDefineProperty2["default"])(this, "worksheetTagIdsHome", _descriptor, this);
    (0, _initializerDefineProperty2["default"])(this, "worksheetTagIdsVideos", _descriptor2, this);
    (0, _initializerDefineProperty2["default"])(this, "worksheetTagIdsPodcast", _descriptor3, this);
    (0, _initializerDefineProperty2["default"])(this, "worksheetProgressTagsHome", _descriptor4, this);
    (0, _initializerDefineProperty2["default"])(this, "worksheetProgressTagsVideos", _descriptor5, this);
    (0, _initializerDefineProperty2["default"])(this, "worksheetProgressTagsPodcast", _descriptor6, this);
    (0, _initializerDefineProperty2["default"])(this, "exerciseTagIds", _descriptor7, this);
    (0, _initializerDefineProperty2["default"])(this, "exerciseProgressTags", _descriptor8, this);
    (0, _initializerDefineProperty2["default"])(this, "vocabSort", _descriptor9, this);
    (0, _initializerDefineProperty2["default"])(this, "exerciseSort", _descriptor0, this);
    (0, _initializerDefineProperty2["default"])(this, "closedGridSections", _descriptor1, this);
    (0, _initializerDefineProperty2["default"])(this, "showExerciseView", _descriptor10, this);
    (0, _initializerDefineProperty2["default"])(this, "selectedLearningPathId", _descriptor11, this);
    (0, _initializerDefineProperty2["default"])(this, "currency", _descriptor12, this);
    this.worksheetTagIdsHome = (0, _utils.getCookieValue)('worksheetTagIdsHome');
    this.worksheetTagIdsVideos = (0, _utils.getCookieValue)('worksheetTagIdsVideos');
    this.worksheetTagIdsPodcast = (0, _utils.getCookieValue)('worksheetTagIdsPodcast');
    this.worksheetProgressTagsHome = (0, _utils.getCookieValue)('worksheetProgressTagsHome');
    this.worksheetProgressTagsVideos = (0, _utils.getCookieValue)('worksheetProgressTagsVideos');
    this.worksheetProgressTagsPodcast = (0, _utils.getCookieValue)('worksheetProgressTagsPodcast');
    this.exerciseTagIds = (0, _utils.getCookieValue)('exerciseTagIds');
    this.exerciseProgressTags = (0, _utils.getCookieValue)('exerciseProgressTags');
    this.vocabSort = (0, _utils.getCookieValue)('vocabSort');
    this.exerciseSort = (0, _utils.getCookieValue)('exerciseSort');
    this.closedGridSections = (0, _utils.getCookieValue)('closedGridSections');
    this.showExerciseView = (0, _utils.getCookieValue)('showExerciseView');
    this.selectedLearningPathId = (0, _utils.getCookieValue)('selectedLearningPathId');
    this.currency = (0, _utils.getCookieValue)('currency');
  }
  return (0, _createClass2["default"])(CookieStore, [{
    key: "set",
    value: function set(prop, value) {
      if (prop in this) {
        this[prop] = value;
        (0, _utils.setCookieValue)(prop, value);
      }
    }
  }, {
    key: "setCookieValue",
    value: function setCookieValue(name, value) {
      (0, _utils.setCookieValue)(name, value);
    }
  }, {
    key: "getCookieValue",
    value: function getCookieValue(name) {
      return (0, _utils.getCookieValue)(name);
    }
  }]);
}(), _descriptor = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "worksheetTagIdsHome", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "worksheetTagIdsVideos", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "worksheetTagIdsPodcast", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor4 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "worksheetProgressTagsHome", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor5 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "worksheetProgressTagsVideos", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor6 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "worksheetProgressTagsPodcast", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor7 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "exerciseTagIds", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor8 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "exerciseProgressTags", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor9 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "vocabSort", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor0 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "exerciseSort", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor1 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "closedGridSections", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor10 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "showExerciseView", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor11 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "selectedLearningPathId", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor12 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "currency", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _class);
var _default = exports["default"] = new CookieStore();